import { selectCurrentView } from 'phoenix2/state/views/selectors';
import { getCurrentTaskId, getViewState } from 'phoenix2/state/viewstates/selectors';
import {
    PACKAGE_LIST_VIEW_ID,
    SKILL_DELIVERY_VIEW_ID,
    TASK_VIEW_ID,
} from 'phoenix2/state/viewstates/view-ids';
import { PACKAGE_TYPE_PRACTICE } from '../content/package-types';
import { getPackage } from '../content/selectors';
import { getTask } from '../content/selectors_ts';

// getIsPracticeHomework returns true if the user is looking at practice packages
// in the package list view, or has selected a practice task.
export const getIsPracticeHomework = (state: any) => {
    const currentView = selectCurrentView(state);
    const packageListViewState = getViewState(state, PACKAGE_LIST_VIEW_ID);
    if (
        currentView?.viewId === PACKAGE_LIST_VIEW_ID &&
        packageListViewState.get('filter') === PACKAGE_TYPE_PRACTICE
    ) {
        return true;
    }
    const currentTaskId = getCurrentTaskId(state);
    const currentTask = getTask(state, currentTaskId);
    const currentPkg = getPackage(state, currentTask?.get('package_id'));
    if (
        (currentView?.viewId === TASK_VIEW_ID || currentView?.viewId === SKILL_DELIVERY_VIEW_ID) &&
        currentPkg !== undefined &&
        currentPkg.get('package_type') === PACKAGE_TYPE_PRACTICE
    ) {
        return true;
    }
    return false;
};
